import axios from "axios";
import { attachRequestHmac } from './hmacUtils';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

// API request function
export const apiRequest = async (endpoint, method, data = null, headers = {}) => {
  const url = `${API_BASE_URL}/${String(endpoint || "").replace(/^\/+/, "")}`;
  const access_token = localStorage.getItem('token');
  const safeHeaders = headers && typeof headers === 'object' ? headers : {};

  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;

  const options = {
    url,
    method: method,
    // Image KYC uploads need longer than JSON calls
    timeout: isFormData ? 120000 : 15000,
    headers: {
      ...safeHeaders,
    },
  };

  if (access_token && !options.headers.Authorization && !options.headers.authorization) {
    options.headers.Authorization = `Bearer ${access_token}`;
  }

  if (data) {
    options.data = data;
  }

  attachRequestHmac(options);

  try {
    const response = await axios(options);

    if (!response) {
      throw new Error(`Error: ${response.status}`);
    }

    return response;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};
